module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-619.f7d1bb09.jpg";